export enum ContactPurpose {
  SpeakToAdviser = 1,
  RequestCallback = 2,
  ConnectWithMentor = 3,
  ContactUs = 4,
  BecomeAMentor = 5,
  HelpCenter = 6,
  Partnerships = 7,
  FreeConsultation = 8,
  MentorClarityCall = 9,
  PeersClarityCall = 10,
  DirectApplyContactUs = 11,
  MyCollegesContactUs = 12,
  InstituteSearchContactUs = 13,
  ExpertCheckoutContactUs = 14
}

// Mapping the enum values to their respective string values
export const ContactPurposeLabels = {
  [ContactPurpose.SpeakToAdviser]: 'Speak To Adviser',
  [ContactPurpose.RequestCallback]: 'Request A Callback',
  [ContactPurpose.ConnectWithMentor]: 'Connect With Mentor',// use this in cta 
  [ContactPurpose.ContactUs]: 'Contact Us',
  [ContactPurpose.BecomeAMentor]: 'Become a Mentor',
  [ContactPurpose.HelpCenter]: 'Help Center',
  [ContactPurpose.Partnerships]: 'Partnerships',
  [ContactPurpose.FreeConsultation]: 'Free Consultation',
  [ContactPurpose.MentorClarityCall]: 'MentorClarityCall',
  [ContactPurpose.PeersClarityCall]: 'PeersClarityCall',
  [ContactPurpose.DirectApplyContactUs]: 'Direct Apply Contact Us',
  [ContactPurpose.MyCollegesContactUs]: 'My Colleges Contact Us',
  [ContactPurpose.InstituteSearchContactUs]: 'Institute Search Contact Us',
  [ContactPurpose.ExpertCheckoutContactUs]: 'Expert Checkout Contact Us'
};
